import React, { useRef, useEffect } from 'react';

import TableHeaderCell from './TableHeaderCell';

function TableHeaderRow(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const { tableName, order, orderBy, columns, handleRequestSort } = props;

    return (
        <thead className="table-header">
            <tr>
                {columns.map((c, colIndex) => {
                    const dataField = c.dataField;
                    const label = c.text;
                    const isActionsColumn = dataField === 'actions';
                    return (
                        <TableHeaderCell
                            key={`table-${tableName}-header-col-${dataField}`}
                            cellKey={`table-${tableName}-header-col-${dataField}`}
                            content={label}
                            dataField={dataField}
                            sortDirection={orderBy === dataField ? order : null}
                            shouldSort={c.sort}
                            handleRequestSort={handleRequestSort}
                            style={{
                                ...(c.headerStyle || {}),
                                ...(isActionsColumn ? { 
                                    position: 'sticky',
                                    right: 0,
                                    backgroundColor: '#1e3a5f',
                                    zIndex: 11,
                                    minWidth: '120px',
                                    width: '120px'
                                } : {})
                            }}
                        />
                    );
                })}
            </tr>
        </thead>
    );
}

export default TableHeaderRow;